import React from 'react';
export function DownloadIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M12.767 16.451l4.06-3.691 1.346 1.48L12 19.85l-6.173-5.61 1.346-1.48 4.06 3.691L11 2h2l-.233 14.451z"
  }), React.createElement("path", {
    d: "M1 8h6v2H3v11h18V10h-4V8h6v15H1V8z"
  }));
}